module.exports = __webpack_public_path__ + "assets/f7a7ad55bcc5f4ac4998fedcf277d26c.jpg";